import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Renderer } from '@df/ng/renderer';
import { Subscription } from 'rxjs/internal/Subscription';
import { BottomPanelService } from './bottom-panel.service';

@Component({
    selector: 'bottom-panel',
    templateUrl: './bottom-panel.component.html',
    styleUrl: './bottom-panel.component.scss',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomPanelComponent implements OnChanges, OnDestroy {
    @Input()
    bottomPanel?: string;

    private areaSubscription?: Subscription;
    private visible = true;

    constructor(
        private elementRef: ElementRef,
        private bottomPanelService: BottomPanelService,
        private renderer: Renderer
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['bottomPanel']) {
            this.areaSubscription?.unsubscribe();

            if (this.bottomPanel) {
                this.areaSubscription = this.bottomPanelService.observe(this.bottomPanel).subscribe(visible => this.toggle(visible));
            } else {
                this.visible = true;
            }
        }
    }

    ngOnDestroy(): void {
        this.areaSubscription?.unsubscribe();
    }

    private toggle(state: boolean): void {
        if (this.visible !== state) {
            this.visible = state;
            this.renderer.setClass(this.elementRef.nativeElement, 'hidden', !this.visible);
        }
    }
}
